// src/components/ProtectedStudentProfileRoute.js
import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '@context';
import { toast } from 'react-toastify';

const ProtectedStudentProfileRoute = ({ children }) => {
  const { auth, profileCheckPassed, isLoading } = useContext(AuthContext);
  const location = useLocation();
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    // 로딩 중이면 검사 X (option)
    if (isLoading) return;

    // 1) 로그인 안 되었거나 role이 'ROLE_USER'가 아니면
    if (!auth.isAuthenticated) {
      toast.info('로그인이 필요합니다.');
      setRedirectPath('/main');
    }
    else if (auth.role !== 'ROLE_USER') {
      toast.info('권한이 없습니다.');
      setRedirectPath('/main');
    }
    // 2) 비밀번호 확인 미완료
    else if (!profileCheckPassed) {
      toast.info('비밀번호 확인 후 이용 가능합니다.');
      setRedirectPath('/myLectures/reconfirm-password/student');
    }
  }, [auth.isAuthenticated, auth.role, profileCheckPassed, isLoading]);

  if (isLoading) {
    // 로딩 중일 때 화면 표시(스피너 등)
    return <div>로딩 중...</div>;
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedStudentProfileRoute;
